/**
 * Pure helpers for strategem ghost slot claims.
 * Keeps bot/opponent kill ghosts from being wiped by reconcile before React state flushes.
 */

/**
 * @param {string|null|undefined} zone
 * @param {number|null|undefined} index
 * @param {string|null|undefined} targetType
 * @returns {string|null}
 */
function getStrategemUnitSlotKey(zone, index, targetType) {
  if (!zone || index === null || index === undefined || targetType === 'general') {
    return null;
  }
  return `${zone}_${index}`;
}

/**
 * @param {string} slotKey
 * @param {Set<string>} activeAnimationSlotKeys
 * @param {Iterable<{ toSlot?: { zone?: string, index?: number|null } }>} activeAnimations
 * @returns {boolean}
 */
function shouldRetainStrategemGhostForEmptySlot(slotKey, activeAnimationSlotKeys, activeAnimations) {
  if (!slotKey) {
    throw new Error('shouldRetainStrategemGhostForEmptySlot: slotKey is required');
  }
  if (activeAnimationSlotKeys instanceof Set && activeAnimationSlotKeys.has(slotKey)) {
    return true;
  }
  const animations = activeAnimations ? Array.from(activeAnimations) : [];
  return animations.some(
    (anim) => anim?.toSlot && `${anim.toSlot.zone}_${anim.toSlot.index}` === slotKey
  );
}

module.exports = {
  getStrategemUnitSlotKey,
  shouldRetainStrategemGhostForEmptySlot,
};
